import { useMemo } from "react";
import { useTranslation } from "@/features/i18n";

interface MaintenanceConfig {
  isEnabled: boolean;
  title: string;
  message: string;
  autoLogout: boolean;
  showButtons: boolean;
}

// Basis-Konfiguration - HIER EINFACH ÄNDERN UM WARTUNG EIN/AUSZUSCHALTEN
const MAINTENANCE_CONFIG_BASE = {
  isEnabled: false, // ← HIER EINFACH AUF false SETZEN UM WARTUNG AUSZUSCHALTEN
  autoLogout: true,
  showButtons: true,
};

export function useMaintenance() {
  const { t } = useTranslation("common");

  // Dynamische Konfiguration mit i18n-Übersetzungen
  const config = useMemo<MaintenanceConfig>(() => {
    return {
      ...MAINTENANCE_CONFIG_BASE,
      title: t("maintenance.platformInDevelopment", {
        defaultValue: "Plattform in Entwicklung",
      }),
      message: t("maintenance.loginRegistrationDisabled", {
        defaultValue:
          "Anmeldung und Registrierung sind derzeit nicht möglich. Bitte habe Geduld - wir arbeiten an tollen neuen Funktionen!",
      }),
    };
  }, [t]); // Abhängig von der Translation-Funktion (ändert sich bei Sprachwechsel)

  return {
    isMaintenanceMode: config.isEnabled,
    config,
  };
}
